import { useEffect, useState } from "react"

import { css, cx } from "@emotion/css"
import { Switch } from "@material-ui/core"

import { useI18n } from "providers/I18n"
import { MbaConfiguration } from "models/mba"

type Props = {
  data: MbaConfiguration | undefined
  update: (
    variables: Partial<MbaConfiguration & { clientConfig?: string }>,
  ) => Promise<Partial<MbaConfiguration>> | void
  id?: string
  disabled?: boolean
  configScope?: "CAMPAIGN" | "CLIENT_AGENCY"
}

export const ExportVersionTracker = (props: Props) => {
  const { t } = useI18n()
  const { data, update, id, disabled, configScope } = props

  const { printVersionTracker } = data ?? {}

  const [checked, setChecked] = useState<boolean>(printVersionTracker ?? false)

  useEffect(() => {
    setChecked(printVersionTracker ?? false)
  }, [printVersionTracker])

  const onCheck = (name: string) => {
    setChecked(!checked)
    update({ id, configScope, [name]: !checked })
  }

  return (
    <div className={styles.container}>
      <h5 className={cx("BodyBody-1BlackBold")}>
        {`${t("mba.config.campaign.exportVersionTracker")}: `}
      </h5>
      <Switch
        size="medium"
        color="primary"
        disabled={disabled}
        checked={checked}
        onChange={() => onCheck("printVersionTracker")}
      />
    </div>
  )
}

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  `,
}
